import script from "./DarkModeToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./DarkModeToggle.vue?vue&type=script&setup=true&lang=js"

import "./DarkModeToggle.vue?vue&type=style&index=0&id=3ed005e4&lang=scss"

const __exports__ = script;

export default __exports__